import React from 'react';
import { FiDroplet } from 'react-icons/fi';
import tnsLogo from '../../../assets/images/tnslogo.png';
import { CheckCircle } from 'lucide-react';

const OPTApproved = ({ onCancel, onTimeout, amount }) => (
  <div className="bg-white text-gray-800 h-full flex flex-col overflow-hidden">
    {/* Header */}
    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0">
      <div className="flex items-center space-x-2">
        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
          <FiDroplet className="w-4 h-4 text-white" />
        </div>
        <span className="font-bold text-gray-800 text-base">Fuel Co</span>
      </div>
      <div className="flex items-center space-x-1.5">
        <span className="text-xs text-gray-400">Powered by</span>
        <img src={tnsLogo} alt="TNS" className="h-5" />
      </div>
    </div>

    {/* Content */}
    <div className="flex-1 flex flex-col items-center justify-center px-6">
      <CheckCircle className="w-12 h-12 text-green-500 mb-2" />
      <div className="text-xl font-bold text-green-600 mb-4">Approved</div>
      
      {/* Transaction details */}
      <div className="w-full max-w-xs space-y-3 mb-6">
        <div className="flex justify-between items-center border-b border-gray-100 pb-2">
          <span className="text-sm text-gray-500">Amount</span>
          <span className="text-lg font-bold text-gray-900">${amount || '0.00'}</span>
        </div>
        <div className="flex justify-between items-center border-b border-gray-100 pb-2">
          <span className="text-sm text-gray-500">Card</span>
          <span className="text-sm font-medium text-gray-700">****1234</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">Approval</span>
          <span className="text-sm font-medium text-gray-700">123456</span>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex space-x-3">
        <button onClick={onCancel}
          className="px-6 py-2.5 bg-white border border-gray-300 text-gray-700 font-semibold text-sm rounded-lg hover:bg-gray-50 transition-colors">
          Cancel
        </button>
        <button onClick={onTimeout}
          className="px-6 py-2.5 bg-blue-600 text-white font-semibold text-sm rounded-lg hover:bg-blue-700 transition-colors">
          Continue
        </button>
      </div>
    </div>
  </div>
);

export default OPTApproved;
